/**
 * "Arz / Talep" sekmesi — Power BI raporunda yok, sonradan istendi.
 *
 * Üstte kapsam şeridi: planın üretildiği an, planlama ufkunun başı ve sonu.
 * Grafikler bir anın değil ufkun toplamını gösteriyor; şerit olmadan "bu
 * sayı hangi saate ait?" sorusu cevapsız kalıyordu. Değerlerin okunuşu
 * lejantta ("ufuk toplamı", "başlangıç stoğu").
 *
 * Altında dört alan (2 × 2): beyaz gövde ön sac, beyaz gövde, renkli gövde
 * ön sac, renkli gövde. Her alanda malzeme başına üretim + başlangıç stoğu
 * (üst üste) ve yanında anamontaj tüketimi. Grup ayrımı ve ölçütler
 * `api.js` → `arzTalep` / `arzKapsam`; grafik `charts/ArzTalep.jsx`.
 */
import { PROD_PATH } from "../api";
import { ARZ_TALEP } from "../charts/ArzTalep";
import { BREAKPOINTS, metinKarti, tvSecici, yiginYerlesim } from "./ortak";

/** Şerit 3 satır + iki sıra grafik 11'er satır. */
export const ARZ_TALEP_ROWS = 25;

const ALANLAR = [
  { id: "beyaz-on", baslik: "Beyaz Gövde Ön Sac", x: 0, y: 3 },
  { id: "beyaz-govde", baslik: "Beyaz Gövde", x: 12, y: 3 },
  { id: "renkli-on", baslik: "Renkli Gövde Ön Sac", x: 0, y: 14 },
  { id: "renkli-govde", baslik: "Renkli Gövde", x: 12, y: 14 },
];

const LAYOUTS = yiginYerlesim([
  ["k-plan", 3],
  ["k-ufuk", 3],
  ...ALANLAR.map((a) => [a.id, 10, 9]),
]);

export function buildArzTalepConfig(rowPx, gap, refreshKey = 0, tvMode = false) {
  const V = tvSecici(tvMode);
  const KAPSAM = { url: `${PROD_PATH}?_t=${refreshKey}#arz-kapsam` };

  /**
   * Şerit kartı. Pano 1920 px'lik tuvale çizilip ekrana küçültüldüğü için
   * buradaki puntolar laptopta yaklaşık üçte bir küçük görünür — ona göre
   * büyük seçildi.
   */
  const serit = (id, baslik, alan, layout) => {
    const t = metinKarti(id, baslik, KAPSAM, alan, layout, LAYOUTS, V);
    // TV'de şerit 44 + değer ~32 + dolgu 6 = 82 px; 3 satırlık karta (en
    // kısa tuvalde ≈ 86 px) sığar.
    t.chart.options.titleStyle = { size: V(22, 19) };
    t.chart.options.valueStyle = { size: V(28, 24) };
    // Başlık şeridi Özet'in küçük kartlarına göre 26 px'e sabit; bu kartlar
    // için yüksekliği CSS'te `.pano-serit` büyütür.
    t.chart.options.className = "pano-kpi pano-serit";
    return t;
  };

  return {
    layout: { columns: 24, rowHeight: rowPx, gap, breakpoints: BREAKPOINTS },
    tiles: [
      serit("k-plan", "Plan Güncellenme Tarihi", "plan_tarihi", { x: 0, y: 0, w: 10, h: 3 }),
      serit("k-ufuk", "Planlama Ufku", "ufuk", { x: 10, y: 0, w: 14, h: 3 }),

      ...ALANLAR.map((a) => ({
        id: a.id,
        source: { url: `${PROD_PATH}?_t=${refreshKey}#arz-${a.id}` },
        layout: { x: a.x, y: a.y, w: 12, h: 11 },
        layouts: LAYOUTS[a.id],
        chart: {
          type: ARZ_TALEP,
          title: a.baslik,
          dimensions: ["malzeme"],
          measures: [],
          options: {
            height: "100%",
            titleStyle: { size: V(26, 20) },
            axisStyle: { size: V(18, 15) },
            labelStyle: { size: V(20, 16) },
            legendStyle: { size: V(19, 15) },
            // Malzeme adı yatay, iki satır (kod / tanım).
            xAxisHeight: V(60, 50),
            yAxisWidth: V(74, 62),
          },
        },
      })),
    ],
  };
}
